import type { StackProps } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import { Actions } from './vy-table-toolbar-components/Actions';
import { CtaButton } from './vy-table-toolbar-components/CtaButton';
import { FilterButton } from './vy-table-toolbar-components/FilterButton';
import { Queries } from './vy-table-toolbar-components/Queries';
import { SearchInput } from './vy-table-toolbar-components/SearchInput';

const VyTableToolbar: React.FC<StackProps> & {
  Queries: typeof Queries,
  Actions: typeof Actions,
  SearchInput: typeof SearchInput,
  CtaButton: typeof CtaButton,
  FilterButton: typeof FilterButton,
} = (props) => {
  return (
    <Stack
      direction="row"
      padding={2}
      spacing={2}
      justifyContent="space-between"
      {...props}
    />
  );
};

VyTableToolbar.Queries = Queries;
VyTableToolbar.Actions = Actions;
VyTableToolbar.SearchInput = SearchInput;
VyTableToolbar.CtaButton = CtaButton;
VyTableToolbar.FilterButton = FilterButton;

export { VyTableToolbar };